import { ICategoryTreeItem, ILightRailItem } from '../../../types'
import {
  RailFullPosterRow,
  RailFullPosterWrap,
  SeparateRailWrap,
} from './ComponentsFactory.style'
import { RailTitle } from '../MainRailPage/MainRailPage.style'
import { RailItemProgram } from '../RailItemProgram/RailItemProgram'
import { useEffect, useMemo, useState } from 'react'

export const FullPoster = ({
  railItems,
  compName,
  showItemTitle,
  data,
}: {
  railItems: ILightRailItem[]
  compName: string
  showItemTitle: boolean
  data: ICategoryTreeItem
}) => {
  const [ItemsInRow, setItemsInRow] = useState<number>()
  const getItemsInRow = () => (window.innerWidth > 768 ? 7 : 3)
  useEffect(() => {
    setItemsInRow(getItemsInRow())
    const onResize = () => {
      setItemsInRow(getItemsInRow())
    }
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  const rows = useMemo(() => {
    const rowsToReturn = []
    if (railItems && ItemsInRow) {
      const tempRailItems = [...railItems]
      while (tempRailItems.length) {
        rowsToReturn.push(tempRailItems.splice(0, ItemsInRow))
      }
    }
    return rowsToReturn
  }, [ItemsInRow, railItems])

  if (!ItemsInRow) {
    return null
  }
  return (
    <SeparateRailWrap
      programWidth={90}
      data-type={compName}
      theme={{ show: true }}
    >
      {showItemTitle && <RailTitle>{data.name.trim()}</RailTitle>}
      <RailFullPosterWrap>
        {rows.map((row, rowIndex) => {
          while (row.length < ItemsInRow) {
            row.push({} as ILightRailItem)
          }
          return (
            <RailFullPosterRow key={'row' + rowIndex}>
              {row.map((r, i) => (
                <RailItemProgram
                  key={r.id + '_' + i}
                  data={r}
                  isFirst={i === 0}
                  isLast={i === railItems.length - 1}
                  showTitle={showItemTitle}
                  compName={'full_poster'}
                />
              ))}
            </RailFullPosterRow>
          )
        })}
      </RailFullPosterWrap>
    </SeparateRailWrap>
  )
}
